import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { WorkoutService, AlertService } from "../../../services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { DomSanitizer } from "@angular/platform-browser";
import * as lodash from "lodash";
import { InjuryService } from "../../../services/injury.service ";
import { ActivatedRoute } from "@angular/router";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AutoUnsubscribe } from "../../../store";

@Component({
  selector: "app-sendgrid-email-history",
  templateUrl: "./sendgrid-email-history.component.html",
  styleUrls: ["./sendgrid-email-history.component.css"],
})
@AutoUnsubscribe
export class SendGridEmailHistoryComponent {
  @Input() formData: any;
  @Output() close = new EventEmitter();

  public injuryHistory: any = [];

  constructor(
    private fb: FormBuilder,
    private _service: InjuryService,
    private spinner: Ng4LoadingSpinnerService,
    private as: AlertService,
    private activeRoute: ActivatedRoute,
    private ds: DomSanitizer
  ) {
    console.log("INJURY HISOTRY ==> ", this.formData);
  }

  public todayDateTime = new Date();

  onCancel(event) {
    this.close.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.injuryHistory = this.formData;
    console.log("Injury History Data => ", this.injuryHistory);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sendgrid/sendgrid-email-history/sendgrid-email-history.component.ts